import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { FormFieldComponent } from "@pishgamrayan/ng-form-kit";
import { takeUntil } from "rxjs";

import { EventTypes } from "src/app/core/constants/event-types";
import { BaseFormPageComponent } from "src/app/pages/shared/base/components/base-form-page.component";

@Component({
    selector: "app-reseller-domain-field",
    templateUrl: "./reseller-domain-field.component.html",
    imports: [FormFieldComponent]
})
// extends BaseFormPageComponent
export class ResellerDomainFieldComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties
  @Input() index: number;
  @Input("isEdit") isEdit: boolean;
  @Input("model") model: any;

  @Output("form") output_form = new EventEmitter<FormGroup>();
  @Output("removeResellerDomain") output_removeResellerDomain =
    new EventEmitter<any>();
  @Output("resellerDomain") output_resellerDomain = new EventEmitter<string>();
  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.fields = "pages.customerDomains.form.fields.";
    this.detectChangeForm();
  }

  initForm() {
    this.form = new FormGroup({
      resellerDomain: new FormControl("", [Validators.required]),
    });
  }

  onRemoveResellerDomain(i) {
    this.output_removeResellerDomain.emit(i);
  }

  emitForm() {
    this.output_form.emit(this.form);
  }

  emitResellerDomain() {
    this.output_resellerDomain.emit(this.model);
  }

  detectChangeForm() {
    try {
      this.form.valueChanges
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((event) => {
          this.emitForm();
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }
}
